import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const browseUrlParamsCache = new Map<string, string>();

/**
 * Preserves browse URL search params per ticket tab so switching tabs restores filters.
 */
export function useTicketBrowseUrlParamsCache() {
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      browseUrlParamsCache.set(location.pathname, location.search);
    }
  }, [location.pathname, location.search]);

  function getUrlParamsSearch(pathname: string): string {
    return browseUrlParamsCache.get(pathname) ?? "";
  }

  return { getUrlParamsSearch };
}
